import {APIService} from "../../common/APIService";
import {QuantityType} from "../../dto/QuantityType";
import {useCallback} from "react";
import moment from "moment/moment";
import {TimeRegistration} from "../../dto/TimeRegistration";

export class TimeRegistrationService extends APIService {

  /**
   * Fetches all hours, within 30 days before and after the given date.
   * @param date
   */
  public async browse(date: Date) {
    const json = await this.getJson<{data: object[]}>(`times/all?date=${Math.floor(date.getTime()/1000)}`)
    return json.data.map(TimeRegistration.fromJson)
  }

  /**
   * Fetches all hours, within the given window.
   * @param fromDate
   * @param toDate
   */
  public async browseByWindow(fromDate: Date, toDate: Date): Promise<{[employeeId: string]: number}> {
    const json = await this.getJson<{data: {[employeeId: string]: number} }>(`bulk_times?fromDate=${Math.floor(fromDate.getTime()/1000)}&toDate=${Math.floor(toDate.getTime()/1000)}`)
    return json.data
  }

  /**
   * Takes all hours in the given windows, exports them to a report, and archives the time registration entries.
   * @param fromDate
   * @param toDate
   */
  public async exportByWindow(fromDate: Date, toDate: Date) {
    const response = await this.postRaw(`bulk_times/export?fromDate=${Math.floor(fromDate.getTime()/1000)}&toDate=${Math.floor(toDate.getTime()/1000)}`, {})
    if (response.status !== 200) {
      console.error(response.status)
      console.error(await response.text())
      throw new Error('Failed to download report')
    }
    return await response.blob()
  }

  /**
   * Add a time registration entry for an employee
   * @param employeeId
   * @param day
   * @param hours
   * @param workorderId
   * @param remark
   */
  public async add(employeeId: string, day: Date, hours: number, workorderId?: string, remark?: string) {
    await this.postJson<void>(`times`, {
      user_id: employeeId,
      date: moment(day).format('YYYY-MM-DD'),
      hours: hours,
      ...((workorderId !== undefined && workorderId !== '-' )
        ? {workorder_id: workorderId} : {}),
      ...(remark !== undefined ? {remark: remark} : {})
    })
  }

  public async update(timeEntryId: string, employeeId: string, day: Date, hours: number, remark?: string) {
    const fields: {[key: string]: string|number} = {
      user_id: employeeId,
      date: moment(day).format('YYYY-MM-DD'),
      hours: hours,
    }
    if (remark !== undefined) {
      fields['remark'] = remark
    }
    await this.putJson<void>(`times/${timeEntryId}`, fields)
  }
}